import { render, staticRenderFns } from "./r-smart-offer-bundle-treasure-offer.vue?vue&type=template&id=27e44c1e"
import script from "./r-smart-offer-bundle-treasure-offer.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-treasure-offer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27e44c1e')) {
      api.createRecord('27e44c1e', component.options)
    } else {
      api.reload('27e44c1e', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-treasure-offer.vue?vue&type=template&id=27e44c1e", function () {
      api.rerender('27e44c1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-treasure-offer/r-smart-offer-bundle-treasure-offer.vue"
export default component.exports